module.exports = __webpack_public_path__ + "img/major.32545ccc.png";